import { BaseManager } from '../core/baseManager';

export interface AppConfig {
    apiUrl: string;
    debug: boolean;
    features: {
        [key: string]: boolean;
    };
    theme: 'light' | 'dark' | 'system';
}

export class ConfigManager extends BaseManager {
    private config: AppConfig;
    private defaultConfig: AppConfig = {
        apiUrl: '/api',
        debug: import.meta.env.VITE_DEBUG === "true",
        features: {},
        theme: 'system'
    };

    constructor() {
        super('ConfigManager');
        this.config = { ...this.defaultConfig };
    }

    public async initialize(): Promise<void> {
        super.initialize();

        this.config = { ...this.defaultConfig };
        this.logger.info('Loaded default configuration');

        //try {
        //    // Load config from server
        //    const response = await fetch('/config/app-config.json');
        //    if (response.ok) {
        //        const serverConfig = await response.json();
        //        this.config = { ...this.defaultConfig, ...serverConfig };
        //        this.logger.info('Loaded configuration from server');
        //    } else {
        //        this.logger.warn('Failed to load configuration from server, using defaults');
        //    }

        //    // Apply theme from config
        //    //this.applyTheme();
        //} catch (error) {
        //    this.logger.error('Error initializing configuration', error);
        //}
    }

    public get<T extends keyof AppConfig>(key: T): AppConfig[T] {
        return this.config[key];
    }

    public set<T extends keyof AppConfig>(key: T, value: AppConfig[T]): void {
        this.config[key] = value;

        // Special handling for theme changes
        if (key === 'theme') {
            //this.applyTheme();
        }

        this.logger.debug(`Updated config: ${String(key)}`);
    }

    public getFeature(featureName: string): boolean {
        return !!this.config.features[featureName];
    }

    public setFeature(featureName: string, enabled: boolean): void {
        this.config.features[featureName] = enabled;
        this.logger.debug(`Updated feature flag: ${featureName} = ${enabled}`);
    }

    //private applyTheme(): void {
    //    const theme = this.config.theme;

    //    if (theme === 'system') {
    //        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    //        document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    //    } else {
    //        document.documentElement.setAttribute('data-theme', theme);
    //    }
    //}
}